/**
 * Small ring used on Home level cards.
 * Pure SVG, tracks a fraction in [0, 1].
 */
interface Props {
  fraction: number
  full?: boolean
  size?: number
}

const R_DEFAULT = 22
const STROKE = 5

export function Ring({ fraction, full = false, size = 52 }: Props) {
  const r = size === 52 ? R_DEFAULT : (size - STROKE) / 2 - 1
  const C = 2 * Math.PI * r
  const clamped = Math.max(0, Math.min(1, fraction))
  const offset = C * (1 - clamped)
  const display = full ? '✓' : `${Math.round(clamped * 100)}%`
  return (
    <div className={`ring${full ? ' full' : ''}`} style={{ width: size, height: size }}>
      <svg viewBox={`0 0 ${size} ${size}`}>
        <circle
          className="track"
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          strokeWidth={STROKE}
        />
        <circle
          className="fill"
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          strokeWidth={STROKE}
          strokeLinecap="round"
          strokeDasharray={C}
          strokeDashoffset={offset}
        />
      </svg>
      <span className="pct">{display}</span>
    </div>
  )
}
